module.exports = __webpack_public_path__ + "img/partnership_05_mobile.204e7d34.jpg";